import ConeSearchContent from '../components/cone-search/ConeSearchContent';

const ConeSearch = () => (
  <div className="px-4 py-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
    <ConeSearchContent showTitle={true} />
  </div>
);

export default ConeSearch;
